import DbBaseObject from "@shared/DbBaseObject";

export default class GenogramLifetimeUpgradeRequest extends DbBaseObject{

	userId: string = null
	targetEmail: string = null
	requestType: string = "genogram_lifetime_5"
	expiresAt: number = 0
	isUsed: boolean = false
	usedAt: number = 0

}
